export class AppConsts {

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'EFactoringManager'
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    static readonly constantes = {
        timeout: 30000
    };
}


// WEBPACK FOOTER //
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/shared/AppConsts.ts